import { combineReducers } from 'redux'
import selected from './get-one'
import all from './get-all'
import newOne from './new'
import editOne from './edit'
import deleteOne from './delete'
import metrics from './get-metrics'
import last from './get-last'

const reducer = combineReducers({
  selected,
  last,
  all,
  newOne,
  editOne,
  deleteOne,
  metrics
})

export default reducer
